import {h, Fragment} from "preact"
import { useSizeOptions } from "@nosto/preact"
import { defaultConfig, sizes } from "../config"
import Pagination from "./Pagination"
import Select from "./elements/Select"

export default function BottomToolbar() {
    const { from, to, total } = useSizeOptions(sizes, defaultConfig.serpSize)

    return (
        <div class="ns-serp-footer ns-page-width">
            <div class="ns-viewed ns-flex ns-items-center ns-justify-center">
                You&rsquo;ve viewed {from === 0 ? "1" : from} - {total < to ? total : to} of {total} product{total === 1 ? '' : 's'}
            </div>
            <Pagination />
            
        </div>
    )
}
